import React from "react";

import { Grid } from "@mui/material";

export const VirtualTour = () => {
  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="center"
      sx={{ flex: 1 }}
    >
      <iframe
        title="Simulador de descarbonização"
        height="100%"
        width="100%"
        style={{ border: "none" }}
        src="https://my.matterport.com/show/?m=P7KQDxyEmgu"
      />
    </Grid>
  );
};